export const getEventCity = event => {
  return event?.location?.city || ''
}

export const getEventVenue = event => {
  return event?.location?.name || ''
}

export const getEventLocationLabel = event => {
  const venue = getEventVenue(event)
  const city = getEventCity(event)

  if (venue && city) {
    return `${venue}, ${city}`
  }

  return venue || city
}
